<template>
  <div
    :class="containerClass"
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <div
      class="p-toast-message-content justify-between flex items-center"
      :class="[convertTheme(message.severity), isClickable && 'cursor-pointer']"
    >
      <div :class="`${!!message?.icon ? 'flex' : ''}`" @click="toCargoList">
        <img
          v-if="!!message?.icon"
          :src="require(`@/app/ui/assets/svg/${message?.icon}.svg`)"
          class="w-5 h-5 mt-1 mr-2"
          alt="success"
        />
        <div class="p-toast-message-text">
          <div
            v-if="message.summary"
            :class="`text-base mb-2 ${message.textColor === 'black' ? 'text-gray-lp-300 font-semibold' : 'text-green-lp-400 font-bold'}`"
            v-sanitize-html="message.summary"
          />

          <div class="p-toast-detail" v-sanitize-html="message.detail"></div>
        </div>
      </div>
      <LpButton
        v-if="isEditable && message.severity !== 'success' && message.editable"
        outline
        :color="message.severity === 'error' ? `red-lp-100` : 'yellow-lp-100'"
        fontWeight="semibold"
        :title="$t('bulkBooking.repair')"
        :bgOutline="
          message.severity === 'error' ? `red-lp-510` : 'yellow-lp-400'
        "
        @click="handleRepairBulk(message.id)"
      />
      <button
        @click="onCloseClick"
        v-if="message.closable !== false"
        type="button"
        v-ripple
      >
        <span
          class="p-toast-icon-close-icon pi pi-times"
          :class="[message?.iconClosePosition !== 'start' && 'pt-6']"
        ></span>
      </button>
    </div>
  </div>
</template>

<script>
import ToastMessage from "primevue/toast/ToastMessage.vue";

export default {
  props: {
    isClickable: {
      type: Boolean,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: false
    },
  },
  extends: ToastMessage,
  methods: {
    toCargoList() {
      this.isClickable && this.$router.push("/cargo-list");
    },

    convertTheme(color) {
      const themes = {
        "succsess": "my-toast-success",
        "error": "my-toast-error",
        "warning": "my-toast-warning"
      }

      return themes[color];
    },

    handleRepairBulk(id) {
      this.$router.push(`/shipment/bulk/bulk-v2/repair-bulk?id=${id}`);
    }
  }
};
</script>
